export const NEWS_PAGE = {
  title: "Actualités de la commune",
  eyebrow: "Informations municipales",
  description:
    "Retrouvez les dernières informations, annonces et temps forts publiés par la commune.",
  heroImageUrl: "https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg",
  crumbs: [
    { label: "Accueil", href: "/" },
    { label: "Ma Ville" },
    { label: "Actualités" },
  ],
};

export const NEWS_LIMIT_OPTIONS = [6, 9, 12, 18, 24];

export const NEWS_SORT_OPTIONS = [
  { value: "created_at", label: "Date de publication" },
  { value: "title", label: "Titre" },
];

export const NEWS_DIR_OPTIONS = [
  { value: "DESC", label: "Plus récentes d’abord" },
  { value: "ASC", label: "Plus anciennes d’abord" },
];